export default {
    apiKey: "AIzaSyCt5PL5ZOQzO85uo48e8T0jtIQUNyDMbxw",
    authDomain: "ecommerce-df1d0.firebaseapp.com",
    databaseURL: "https://ecommerce-df1d0.firebaseio.com",
    projectId: "ecommerce-df1d0",
    storageBucket: "ecommerce-df1d0.appspot.com",
    messagingSenderId: "157662722071",
    appId: "1:157662722071:web:c453133263c8c9be1e4452"
};
